var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartOptions)?_c('highcharts',{staticStyle:{"height":"100%"},attrs:{"constructor-type":'stockChart',"options":_vm.chartOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }